import { render, staticRenderFns } from "./CobranzaCreate.vue?vue&type=template&id=6195ba90"
import script from "./CobranzaCreate.vue?vue&type=script&lang=js"
export * from "./CobranzaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports